import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import BiotechReadiness from "@/pages/BiotechReadiness";

export const Route = createFileRoute("/en/biotech-readiness")({
  head: () => buildRouteHead("/en/biotech-readiness"),
  component: BiotechReadiness,
});

